import { render, staticRenderFns } from "./lab-details.vue?vue&type=template&id=589b98bf&"
import script from "./lab-details.vue?vue&type=script&lang=js&"
export * from "./lab-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports